import type Asset from '../asset'
import { type FilterJSON } from './types'
import type FilterOption from './filterOption'

export function isRatingFilterJSON( json: FilterJSON ): json is { rating: number[] } {
	return typeof json === 'object' && json !== null && 'rating' in json && Array.isArray( json.rating )
}

export default class RatingFilter implements FilterOption {
	ratings: number[]

	constructor( ratings: number[] ) {
		this.ratings = ratings
	}

	get id() {
		return `rating-${[ ...this.ratings ].sort( ( a, b ) => a - b ).join( '_' )}`
	}

	get filterAmount() {
		return this.ratings.length > 0 ? 1 : 0
	}

	isPassedBy( asset: Asset ) {
		const rating = asset.effectiveRating
		return rating !== null && this.ratings.includes( rating )
	}

	toJson() {
		return { rating: this.ratings }
	}

	static fromJson( json: FilterJSON ) {
		return isRatingFilterJSON( json )
			? new RatingFilter( json.rating )
			: null
	}
}
